var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 94.8,
    width: 11.6,
    height: 7.2,
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80.8,
    y: 59.6,
    width: 22,
    height: 23.6,
    fillOpacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 103.6,
    width: 11.6,
    height: 7.2,
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8 11.6C31.6 13.6 24.68 23.88 24.68 23.88V81.32C19 81.32 8.76001 81.36 8.76001 81.36V95.48L24.68 95.52V114.32H42.76V95.52H54.4V81.32H42.76C42.76 81.36 42.8 14.4 42.8 11.6ZM91.88 43.3599C76.36 43.3599 63.76 55.9999 63.76 71.4799C63.76 86.9599 76.4 99.5999 91.88 99.5999C107.36 99.5999 120 86.9599 120 71.4799C120 55.9999 107.36 43.3599 91.88 43.3599ZM28.68 25.88C30.4 23.2 36 18.4 38.76 17.72V81.32H28.68V40.16V25.88ZM12.76 91.52V85.4C13.6861 85.4 22.9293 85.3859 30.439 85.3745L30.4974 85.3744L30.5077 85.3744C35.6179 85.3666 39.9087 85.36 40.2 85.36V91.56L12.76 91.52ZM44.32 91.56H50.4V85.36H44.32V91.56ZM111 68.64V75.24C112.36 75.24 115.32 75.24 115.92 75.2C114.32 85.84 105.8 94.24 95.08 95.6C95.08 95.2521 95.0731 94.5751 95.0651 93.7847L95.065 93.7699L95.0649 93.7687V93.7678V93.7672C95.0536 92.6522 95.04 91.3159 95.04 90.36H88.48V95.52C77.96 94 69.64 85.72 68.04 75.2H72.56V68.6H67.96C69.28 57.76 77.72 49.2 88.48 47.64V53.48H95.08V47.6C106.04 49 114.68 57.68 116 68.64H111ZM104.52 83.2C105.24 82.44 105.68 81.44 105.68 80.36V63.64C105.68 62.56 105.28 61.56 104.52 60.8L102.96 59.24C102.2 58.52 101.2 58.08 100.12 58.08H83.4C82.32 58.08 81.32 58.48 80.56 59.24C80.4813 59.3187 80.3123 59.4791 80.1136 59.6676L80.113 59.6682L80.1097 59.6714L80.1092 59.6718L80.1085 59.6724L80.108 59.673C79.7015 60.0587 79.1738 60.5594 79.04 60.72C78.32 61.48 77.88 62.48 77.88 63.56V79.84C77.88 80.92 78.28 81.92 79.04 82.68L81.04 84.68C81.8 85.4 82.8 85.84 83.88 85.84C84.9465 85.84 91.6648 85.8578 96.133 85.8696L96.2491 85.8699L96.3403 85.8701L96.3642 85.8702H96.366L96.4345 85.8704C98.517 85.8759 100.045 85.88 100.16 85.88C101.24 85.88 102.24 85.48 103 84.72L104.52 83.2ZM28.68 101H38.76V95.56H28.68V101ZM38.76 110.36H28.68V105.32H38.76V110.36ZM82.6086 62.3708L82.6078 62.3716C82.3488 62.6208 82.0953 62.8647 81.88 63.08V79.36L83.88 81.36C85.5103 81.36 91.1349 81.3757 95.3307 81.3874C97.8266 81.3944 99.8169 81.4 100.16 81.4L101.68 79.88V63.16L100.12 61.6H83.4C83.1551 61.8449 82.8789 62.1107 82.6086 62.3708Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSns);
export default __webpack_public_path__ + "static/media/sns.0062fd6ee01f40aa75be893730429163.svg";
export { ForwardRef as ReactComponent };